import React from "react"
import axios from 'axios'
import { Box, Button, Card, Container, Divider, Typography } from "@mui/material"
import Grid2 from "@mui/material/Unstable_Grid2"

function ShopStocks() {
  const [aggregate, setAggregate] = React.useState([])
  const loadAggregate = async function () {
    const aggregateRes = await axios.post("https://opsloth.com/api/erp_extra_4_items/aggregate", [{
      $match: {
        location: { $nin: ["诚品", null, "时代天街-扭蛋机", "百脑汇", "天幕", "杭州 热气球", "我的仓库", "广州养殖场", "测试区域1", "测试区域2", "武夷山", "金华自然博物馆", "黑金", "天府红楼下今站"] },
        deleted: { $ne: true },
      },
    }, {
      $group: {
        _id: {
          "location": "$location",
          "filter_type": "$filter_type",
        },
        "number_multiply_cost": { $sum: { $multiply: ["$cost", "$stock"] } },
        "no_zero_stock": { $sum: { $cond: { if: { $gt: ["$stock", 0] }, "then": 1, "else": 0 } } },
        "stocks": { $sum: "$stock" },
      }
    },
    {
      $project: {
        _id: "$_id.location",
        number_multiply_cost: { k: { $ifNull: ["$_id.filter_type", "未分类"] }, v: "$number_multiply_cost" },
        no_zero_stock: { k: { $ifNull: ["$_id.filter_type", "未分类"] }, v: "$no_zero_stock" },
        stocks: { k: { $ifNull: ["$_id.filter_type", "未分类"] }, v: "$stocks" }
      }
    },
    {
      $group: {
        _id: "$_id",
        number_multiply_cost: { $push: "$number_multiply_cost" },
        no_zero_stock: { $push: "$no_zero_stock" },
        stocks: { $push: "$stocks" }
      }
    },
    {
      $project: {
        _id: "$_id",
        number_multiply_cost: { $arrayToObject: "$number_multiply_cost" },
        no_zero_stock: { $arrayToObject: "$no_zero_stock" },
        stocks: { $arrayToObject: "$stocks" }
      }
    }

    ])

    let sumTotal = {
      number_multiply_cost: { "一番赏": 0, "手办": 0, "扭蛋": 0, "未分类": 0, "毛绒": 0, "盲盒": 0, "谷子": 0 },
      no_zero_stock: { "一番赏": 0, "手办": 0, "扭蛋": 0, "未分类": 0, "毛绒": 0, "盲盒": 0, "谷子": 0 },
      stocks: { "一番赏": 0, "手办": 0, "扭蛋": 0, "未分类": 0, "毛绒": 0, "盲盒": 0, "谷子": 0 },
      _id: " 总计（仓扭蛋未计）"
    }
    aggregateRes.data.forEach((item: any) => {
      Object.keys(item.no_zero_stock).forEach((key: string) => {
        (sumTotal.no_zero_stock as any)[key] += item.no_zero_stock[key]
      })
      Object.keys(item.number_multiply_cost).forEach((key: string) => {
        (sumTotal.number_multiply_cost as any)[key] += item.number_multiply_cost[key]
      })
      Object.keys(item.stocks).forEach((key: string) => {
        (sumTotal.stocks as any)[key] += item.stocks[key]
      })
    })
    aggregateRes.data.unshift(sumTotal)
    setAggregate(aggregateRes.data)
  }
  React.useEffect(() => {
    loadAggregate()
  }, [])

  return (

    <Grid2 container width='100%' sx={{ display: 'flex' }}>
      {
        aggregate.sort((a, b) => (a['_id'] as string).localeCompare(b['_id'])).map((aggregate: any) => {
          let totalNumberMultiCost = 0
          return <Grid2
            xs={6}
            sm={4}
            md={3}
            lg={2}
            xl={2}
          >
            <Card sx={{ m: 1, p: 2, height: '92%'}}>
              {<Typography variant="h5">{aggregate['_id']}</Typography>}
              {
                Object.keys(aggregate).map(item =>
                  <div>{
                    <Typography variant="h6" sx={{ mt: 2 }}>
                      {item == 'number_multiply_cost' && <Box>剩余成本库存：</Box>}
                      {item == 'no_zero_stock' && <Box>非零款式数</Box>}
                      {item == 'stocks' && <Box>库存数（最小单位）：</Box>}
                    </Typography>
                  }
                    {
                      item != "_id" && Object.keys(aggregate[item]).sort().map((subItem, subIndex) => {
                        if (item == 'number_multiply_cost') {
                          {
                            totalNumberMultiCost += aggregate[item][subItem]
                          }
                          if (subIndex == Object.keys(aggregate[item]).length - 1) {
                            return <Box sx={{ display: 'flex', flexWrap: 'nowrap', flexDirection: 'column' }}>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography variant="body1" sx={{ color: '#4b5763', fontWeight: 'bold' }}>{subItem}</Typography>
                                <Typography variant="body1" sx={{ color: '#4b5763' }}>{parseFloat(aggregate[item][subItem]).toFixed(2)}元</Typography>
                              </Box>
                              <Divider sx={{ my: .5 }}></Divider>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                <Typography variant="body1" sx={{ color: '#4b5763', fontWeight: 'bold' }}>合计</Typography>
                                <Typography variant="body1" sx={{ color: '#4b5763' }}>{totalNumberMultiCost.toFixed(2)}元</Typography>
                              </Box>
                            </Box>
                          } else {
                            return <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                              <Typography variant="body1" sx={{ color: '#4b5763', fontWeight: 'bold' }}>{subItem}</Typography>
                              <Typography variant="body1" sx={{ color: '#4b5763' }}>{parseFloat(aggregate[item][subItem]).toFixed(2)}元</Typography>
                            </Box>
                          }
                        } else if (item == 'no_zero_stock') {
                          return <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography variant="body1" sx={{ color: '#4b5763', fontWeight: 'bold' }}>{subItem}</Typography>
                            <Typography variant="body1" sx={{ color: '#4b5763' }}>{aggregate[item][subItem]}款</Typography>
                          </Box>
                        } else if (item == 'stocks') {
                          return <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography variant="body1" sx={{ color: '#4b5763', fontWeight: 'bold' }}>{subItem}</Typography>
                            <Typography variant="body1" sx={{ color: '#4b5763' }}>{aggregate[item][subItem]}个</Typography>
                          </Box>
                        } else {

                        }
                      }
                      )
                    }</div>
                )
              }
            </Card>
          </Grid2>
        })
      }
    </Grid2>
  )
}

export default ShopStocks